import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  loginBrokerClear,
  loginClear,
  logoutBroker,
  logoutBrokerClear,
  logoutClear,
} from "../../redux/auth/actions";
import {
  isAggree,
  isAggreeClear,
  privacyContentReq,
} from "../../redux/roleplay/actions";
import { checkCall, SessionKeys } from "../../utils/AppUtils";
import $ from "jquery";
import CONFIG from "../../utils/config";
import TermsOfUseComp from "../FooterSectComponents/TermsOfUseComp";
import { isAndroid, isIOS } from "react-device-detect";

const PrivacyandTerms = (props) => {
  const { setIsLoading } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const webView = params.get("webView");
  const userRole = useSelector((state) => state.user.role);
  const isAggreeRes = useSelector((state) => state.rolePlay.isAggree);
  const privacyContentRes = useSelector(
    (state) => state.rolePlay.privacyContent
  );
  const authLogoutBroker = useSelector((state) => state.auth.authLogoutBroker);
  const auth = useSelector((state) => state.auth);

  const [privacyContent, setPrivacyContent] = useState("");

  const [check, setCheck] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(SessionKeys.IS_AGGREED) === "true" || true) {
      
      if(userRole.includes("provider")){
        console.log("userRole",userRole)
        navigate("/profile/detail")
      }else{
        navigate("/home");
      }
    } else {
      getPrivacyContent();
    }
  }, []);

  useEffect(() => {
    // console.log('privacyContentRes: ', privacyContentRes)
    if (!_.isEmpty(privacyContentRes)) {
      if (privacyContentRes?.status === "success") {
        setPrivacyContent(privacyContentRes?.payload?.payload);
      }
    }
  }, [privacyContentRes]);

  useEffect(() => {
    // console.log('isAggreeResponse: ', isAggreeRes)
    if (!_.isEmpty(isAggreeRes)) {
      setIsLoading(false);
      if (isAggreeRes?.status === "success") {
        localStorage.setItem(SessionKeys.IS_AGGREED, true);
      
        let redirectPath = "/home";
        if(userRole.includes("provider")){
          
           redirectPath = "/profile/detail";

           console.log("userRole",userRole,"redirectPath",redirectPath)
           console.log("inside")
        }
        if (localStorage.getItem(SessionKeys.LOCATION_PATH_REDIRECT)) {
          const locationPath = JSON.parse(
            localStorage.getItem(SessionKeys.LOCATION_PATH_REDIRECT)
          );
          if (!_.isEmpty(locationPath)) {
            redirectPath = locationPath.path;
            if (locationPath.query) {
              redirectPath = redirectPath + "/" + locationPath.query;
            }
            localStorage.removeItem(SessionKeys.LOCATION_PATH_REDIRECT);
          }
        }
        if (userRole.includes("provider")) {
          navigate(redirectPath, {
            replace: true,
            state: { role: "provider" },
          });
        } else {
          navigate(redirectPath, { replace: true });
        }
        // navigate(redirectPath, { replace: true });
        dispatch(isAggreeClear());
        // navigate("/home");
      }
    }
  }, [isAggreeRes]);

  const getPrivacyContent = () => {
    dispatch(
      privacyContentReq({
        module: "privacyContent",
        postData: {},
      })
    );
  };

  const signOut = () => {
    setIsLoading(true);
    dispatch(
      logoutBroker({
        module: "userlogout",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
      })
    );
  };

  useEffect(() => {
    // console.log('LOGOUT IS CALLED', authLogoutBroker)
    if (!_.isEmpty(authLogoutBroker)) {
      setIsLoading(false);
      window.captureMyEvents("logout", {
        userId: auth?.authBroker?.payload.user.user_id,
        message: "User logged out",
      });
      let email = null,
        pass = null;
      if (localStorage.getItem(SessionKeys.IS_REMEMBERED)) {
        email = localStorage.getItem(SessionKeys.EMAIL);
        pass = localStorage.getItem(SessionKeys.PASS);
      }
      // alert('Logout button clicked',authLogoutBroker)
      localStorage.clear();

      if (email !== null) {
        localStorage.setItem(SessionKeys.IS_REMEMBERED, true);
        // localStorage.setItem(SessionKeys.EMAIL, email);
        // localStorage.setItem(SessionKeys.PASS, pass);
      }

      $("html").css("--color-element-1", CONFIG.COLOR_ELEMENT_1);
      $("html").css("--color-element-2", CONFIG.COLOR_ELEMENT_2);
      dispatch(logoutClear());
      dispatch(loginClear());
      // dispatch(setUserPremium(false))
      // logoutClearSession();

      dispatch(loginBrokerClear());
      dispatch(logoutBrokerClear());

      navigate("/", { logout: true });
    }
  }, [authLogoutBroker]);

  return (
    <section className="privacy-termspage">
      <div className="container">
        <div className="row">
          <div className="col-md-8">
            <div className="initialtermspage">
              {false && (
                <h2 className="headingtermsec my-4">
                  NIIT Learning Solutions (Canada) Limited [NIIT Canada] User
                  Terms of Service
                </h2>
              )}
              <h2 className="headingtermsec my-4">User Terms of Service</h2>
              <p className="regularcontent">Last updated April 2024.</p>
              <ul>
                <li>
                  <p className="regularcontent">
                    Welcome to [NIIT Learning Solutions Canada Ltd. [NIIT
                    Canada] [Subscription Services] Platform (the “Platform”).
                    Please read these terms and conditions carefully before
                    using the Platform. By accessing the Platform or using any
                    [NIIT Learning Solutions Canada Ltd.] Learning Services
                    accessible via the Platform (the “Services”), you agree to
                    these User Terms of Service (the “Terms”).
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Your use of the Platform and Services is also subject to our
                    Cookie Policy and our Privacy Policy, which covers how NIIT
                    Canada collect, use, share, and store your personal
                    information.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    You agree that by clicking “I Agree”, registering, accessing
                    or using our Services, you are agreeing to enter into a
                    legally binding agreement with NIIT Canada
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    If you have any questions relating to the terms and
                    conditions, please contact Support@halifax.app
                  </p>
                </li>
              </ul>
              {false && (
                <p className="regularcontent">
                  By clicking on the “I Agree” button below, you acknowledge
                  that you have read, understood, and agree to be bound by NIIT
                  Canada’s User Terms of Service.
                </p>
              )}
              <h2 className="headingtermsec my-4">Availability</h2>
              <p className="regularcontent">
                NIIT Canada aims and endeavour is to ensure you have access to
                the Platform at all times. Although on occasion NIIT Canada may
                encounter unexpected interruptions, NIIT Canada will strive to
                resolve the issues at the earliest and give the best service. In
                case of any planned software updates or other interruptions, the
                users will be informed in advance.
              </p>

              <h2 className="headingtermsec my-4">Security</h2>
              <p className="regularcontent">
                NIIT Canada uses physical, electronic, and administrative
                measures designed to secure the Platform, Content (defined
                below) and information provided, from accidental loss and from
                unauthorized access, use, alteration, and disclosure. However,
                we cannot guarantee the security of the information transmitted
                to and from the Platform.
              </p>
              <h2 className="headingtermsec my-4">
                Our Right to Vary These Terms and Conditions
              </h2>
              <p className="regularcontent">
                NIIT Canada may modify these Terms from time to time. NIIT
                Canada reserves the right to change data, references,
                specifications, or any other information contained in or on the
                Platform at any time, without notice to you. If NIIT Canada
                makes material changes to any of the Terms, NIIT Canada will
                provide you notice through the Platform, and/or by other
                channels, to provide you the opportunity to review the changes.
                No changes will be imposed on you retroactively. If you object
                to any changes, you may discontinue using your subscription,
                suspend the use of the Platform and Services. Your continued
                access of the Platform and/or use of our Services after NIIT
                Canada publish or send a notice about the changes to these Terms
                means that you are consenting to the updated Terms as of the
                date of the update set forth above.
              </p>
              <h2 className="headingtermsec my-4">Use of the Platform </h2>
              <p className="regularcontent">
                NIIT Canada grant you a revocable, personal, non-exclusive,
                non-transferrable, limited, non-assignable and non-exclusive
                right to use the Platform and Services, accessible via equipment
                or other sanctioned device controlled by you, and to access and
                use the Platform and Services strictly in accordance with these
                Terms, and for your internal business purposes only. You may use
                the Platform only in the manner described expressly in the Terms
                and subject to all applicable laws. Using the Platform for any
                other purpose or in any other manner is strictly prohibited. You
                acknowledge that no title to the intellectual property in the
                Platform or Services will be transferred to you or any Account
                holder.
              </p>
              <h2 className="headingtermsec my-4">Your Account</h2>
              <p className="regularcontent">
                You will access the Platform and Services by using the
                credentials of the applicable account subscriber. You shall not
                share the password or other account credentials with anyone, and
                you are responsible for anything that happens through your
                account unless you close it or report any misuse.
              </p>
              <h2 className="headingtermsec my-4">Commercial Terms</h2>
              <p className="regularcontent">
                “User Reward Points” means the points which are accumulated and
                earned by the Users for purchases made by the Users on the
                Platform and which in return the Users can utilize for buying
                further paid services on the platform (including Third Party
                Services). These points will not be available for use against
                Subscription Fees or against charges payable for upgrading. Such
                points would not be redeemable in cash or equivalent at any
                point in time.
              </p>
              <p className="regularcontent">
                When posting, publishing, sending or uploading User Content
                (defined below), or otherwise using the Platform and Services,
                you agree to follow and comply with our list of Dos and Don’ts..
              </p>
              {false && (
                <>
                  {" "}
                  <p className="regularcontent">
                    <span className="boldcontent">Basic User:</span>{" "}
                    <span className="regularcontent">
                      Will earn 1 reward point on learning purchases for every
                      $1 spent. Reward points collected may be redeemed at the
                      time of future purchases.
                    </span>
                  </p>
                  <p className="regularcontent">
                    <span className="boldcontent">Premium User:</span>{" "}
                    <span className="regularcontent">
                      Will earn 2 reward points on learning purchases, for every
                      $1 spent. Reward points collected may be redeemed for
                      future purchases. You agree to follow the law and our list
                      of Dos and Don’ts. You are responsible for anything that
                      happens through your account unless you close it or report
                      any misuse.
                    </span>
                  </p>
                </>
              )}
              <h2 className="headingtermsec my-4">Dos</h2>
              <p className="regularcontent">You agree that you will:</p>
              <ul>
                <li>
                  <p className="regularcontent">
                    Comply, at all times, with all applicable laws, regulations
                    and ordinances related to your use of the Platform and
                    Services, including, without limitation, privacy laws,
                    intellectual property laws, anti-spam laws (whether Canadian
                    or international), export control laws, tax laws, and
                    regulatory requirements.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Provide accurate and complete information to us and keep it
                    updated.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Use your real name on your profile.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Professionally use the Platform and Services.
                  </p>
                </li>
                {false && (
                  <>
                    {" "}
                    <li>
                      <p className="regularcontent">
                        Use the Platform and Services in a professional manner.
                      </p>
                    </li>
                    <li>
                      <p className="regularcontent">
                        Will comply, at all times, with Canadian and
                        international anti-spam legislation, rules, and
                        regulations.
                      </p>
                    </li>
                  </>
                )}
              </ul>
              <h2 className="headingtermsec my-4">Don’ts</h2>
              <p className="regularcontent">You agree that you will not:</p>
              <ul>
                <li>
                  <p className="regularcontent">
                    Create a false identity on the Platform, misrepresent your
                    identity, create a user account for anyone other than
                    yourself (a real person), or use or attempt to use another’s
                    account.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Develop, support or use software, devices, scripts, robots
                    or any other means or processes (including crawlers, browser
                    plugins and add-ons or any other technology) to scrape the
                    Platform or otherwise copy profiles and other data from the
                    Services.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Override any security feature or bypass or circumvent any
                    access controls or use limits of the Platform (such as caps
                    on keyword searches or profile views).
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Copy, use, disclose, rent, lease, sell, or distribute any
                    information obtained from the Services, whether directly or
                    through third parties (such as, but not limited to, search
                    engines), without the consent of NIIT Canada.
                  </p>
                </li>

                <li>
                  <p className="regularcontent">
                    Modify, translate, rent, copy, transfer or assign all or
                    part of the Services, or any rights granted hereunder, to
                    any other persons.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Download, archive, store, copy, reproduce, collect, compile,
                    recompile, use, modify, adapt, translate or prepare any
                    summaries, digests, derivative works, of the Platform and
                    Services and their Content (defined below), in whole or in
                    part, including any photograph, description, reference,
                    picture or other data or information obtained or derived
                    from the Platform and Services (excluding rights you have to
                    access, and view under the terms hereof).
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Remove any proprietary notices, labels or marks from the
                    Platform, the Content (defined below) and the Services.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Disclose information that you do not have consent to
                    disclose (such as confidential information of others).
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Violate the intellectual property rights of others,
                    including copyrights, patents, trademarks, trade secrets or
                    other proprietary rights. For example, do not copy or
                    distribute (except through the available sharing
                    functionality) the posts or other content of others without
                    their permission.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Sell the Platform. You acknowledge that title and full
                    ownership rights to the Platform and the Services will
                    remain the exclusive property of NIIT Canada. Your use of
                    the Platform and Services is subject to individual use only,
                    in accordance with the Terms. No title to the intellectual
                    property in the Platform or Services is transferred to you
                    as the Customer.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Violate the intellectual property or other rights of NIIT
                    CANADA, including, without limitation, (i) copying or
                    distributing our learning videos or other materials or (ii)
                    copying or distributing our technology, unless it is
                    released under open-source licenses, for which you agree to
                    comply with relevant terms of said open-source licence;
                    (iii) using the word “NIIT CANADA” or our logos in any
                    business name, email, or URL except as provided in our
                    branding guidelines.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Post User Content or any other content that contains
                    software viruses, Trojan horses, worms, spiders, malware,
                    logic bombs, any other material that is malicious or
                    technologically harmful or any other harmful code.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Reverse engineer, decompile, disassemble, decipher or
                    otherwise attempt to derive the source code for the Services
                    and Platform.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Imply or state that you are affiliated with or endorsed by
                    NIIT CANADA/NIIT without our express consent (e.g.,
                    representing yourself as an accredited NIIT trainer).
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Rent, lease, loan, trade, sell/re-sell or otherwise monetize
                    the Services, Platform or related data or access to the
                    same, without NIIT’s consent.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Use the deep-link to our Services for any purpose other than
                    to promote your profile without NIIT CANADA consent.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Use bots or other automated methods to access the Platform
                    or Services, add or download contacts, and send or redirect
                    messages.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Monitor the Services’ availability, performance or
                    functionality for any competitive purpose.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Engage in “linking”, “framing,” “mirroring,” or otherwise
                    simulating the appearance or function of the Platform or
                    Services.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Overlay or otherwise modify the Platform or Services or
                    their appearance (such as by inserting elements into the
                    Platform or Services or removing, covering, or obscuring an
                    advertisement included on the Platform or Services).
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Interfere with the operation of, or place an unreasonable
                    load on, the Platform or Services (e.g., spam, denial of
                    service attack, viruses, gaming algorithms).
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Violate any of the Platform or Services policies or any
                    additional terms concerning any Service.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Upload, copy, distribute, share, or otherwise use User
                    Content that is unlawful, obscene, defamatory, libellous,
                    harmful, hateful, harassing, bullying, pornographic,
                    threatening, racially or ethnically offensive or abusive,
                    that would violate another person's rights (including their
                    intellectual property rights), constitute or encourage a
                    criminal offence, give rise to civil liability, or violate
                    any local, state, provincial, national or international law
                    or regulation, or that is otherwise inappropriate;
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Post or transmit junk mail, chain letters, unsolicited mass
                    mailing or spam
                  </p>
                </li>
              </ul>
              <p className="regularcontent">
                In addition to the above, you agree to not upload, transmit,
                disseminate, post, or store User Content as well as any links to
                any content that:
              </p>
              <p className="regularcontent">
                (a) facilitates hacking or unauthorized access or use of data,
                systems, servers or networks including any attempt to probe,
                scan or test for vulnerabilities, or to breach security or
                authentication measures;
              </p>
              <p className="regularcontent">
                (b) interferes with service to any user, system or network by
                using flooding techniques, denial-of-service attacks,
                distributed denial-of-service attack, mailbombing, crashing,
                overloading a system or a network, staging or broadcasting an
                attack or any other means resulting in a crash of a host either
                deliberately or by negligence;
              </p>
              <p className="regularcontent">
                (c) infringes on, or contributes to any infringement of, any
                intellectual property, material protected by copyright,
                trademark, patent, trade secrets or proprietary right of any
                party.
              </p>
              <p className="regularcontent">
                (d) violates or infringes upon the rights of others, including
                material which is an invasion of privacy or publicity rights or
                which is protected by any intellectual property rights,
                including, without limitation, copyright, patent, trade secrets,
                trademark or other proprietary rights herein, or derivative
                works with respect thereto, without first obtaining permission
                from the owner or rights holder; and
              </p>
              <p className="regularcontent">
                (e) contains advertising or which engage in commercial
                activities and/or sales, or which involve contests, sweepstakes,
                barter and/or advertising.
              </p>

              <h2 className="headingtermsec my-4">User Content </h2>
              <p className="regularcontent">
                The Platform may allow you to post, send or upload files,
                documents or other materials (collectively, the “User Content”).
              </p>
              <p className="regularcontent">
                By sending, posting or uploading User Content to the Platform,
                you grant NIIT Canada a royalty-free, perpetual, non-exclusive,
                irrevocable, unrestricted, worldwide licence to use, reproduce,
                store, adapt, translate, modify, make derivative works from,
                transmit, distribute, publicly perform or display such User
                Content for any purpose. In addition, you hereby agree to waive
                all moral rights in any User Content in favour of NIIT Canada,
                and acknowledge and agree that any User Content you provide for
                display on the Platform will be considered non-confidential. You
                hereby warrant that any User Content you send, post or upload on
                the Platform does not contravene nor infringe on third party
                rights, including but not limited to third-party’s intellectual
                property rights, titles and interests.
              </p>
              <p className="regularcontent">
                NIIT Canada may from time-to-time monitor or review postings,
                transmissions, uploading, and the like of, on the Platform to
                ensure compliance with the Terms. NIIT Canada reserves the
                right, in its sole discretion, to refuse to post, edit or remove
                any User Content. You acknowledge and agree that NIIT Canada
                may, in its sole discretion, monitor the Platform periodically
                and disclose any information as necessary to satisfy any law,
                regulation or other governmental or court request, to operate
                the Platform properly or to protect itself or other users of the
                Platform. NIIT Canada is under no obligation to do so and assume
                no responsibility or liability arising from the User Content of
                any such locations nor for any error, omission, infringement,
                defamation, obscenity, or inaccuracy contained in any
                information within such locations on the Platform. You
                acknowledge that you remain solely responsible for the content
                of the User Content you send, post or upload, including the
                legality, reliability, appropriateness and originality thereof.
              </p>
              <h2 className="headingtermsec my-4">General Terms</h2>
              <p className="regularcontent">
                You agree that NIIT Canada, in its sole discretion, has the
                right (but not the obligation) to delete or deactivate your
                Account or otherwise terminate your access to or use of the
                Platform (or any part thereof), immediately and without notice,
                for any reason, including, without limitation, if NIIT Canada
                believes that you have acted inconsistently with the letter or
                spirit of the Terms.
              </p>
              <p className="regularcontent">
                If a court with authority over these Terms finds the Terms, in
                whole or in part, to be unenforceable, you and NIIT Canada agree
                that the court should modify the Terms to make that part
                enforceable while still achieving its intent. If the court
                cannot do that, you and NIIT Canada agree to ask the court to
                remove that unenforceable part and still enforce the rest of the
                Terms.
              </p>
              <p className="regularcontent">
                These Terms are the only agreement between NIIT Canada regarding
                your use of the Platform and the Services and supersedes all
                prior agreements for the Platform and Services.
              </p>
              <p className="regularcontent">
                Failure to enforce any of the terms by NIIT Canada, does not
                mean that NIIT Canada has waived its right to enforce these
                Terms. You may not assign or transfer these Terms (or your
                subscription or use of the Platform or Services) to anyone
                without our consent. However, you agree that NIIT Canada may
                assign these Terms to its affiliates or a party that buys it
                without your consent. There are no third-party beneficiaries to
                these Terms.
              </p>
              <p className="regularcontent">
                The provisions of the Terms shall enure to the benefit of and be
                binding upon NIIT Canada and its successors and assigns and
                related persons, and you and your heirs, executors,
                administrators, successors, and personal representatives (and
                those of any person you represent). You cannot assign any of
                your rights or delegate any of your obligations under the Terms.
                We may, however, assign any of our rights and obligations under
                these Terms to a third party, without obtaining your prior
                consent.
              </p>
              {false && (
                <p className="regularcontent">
                  You agree that the only way to provide us legal notice is at
                  the addresses provided under “Contact us”.
                </p>
              )}
              <h2 className="headingtermsec my-4">
                Governing Law and Dispute Resolution
              </h2>
              <p className="regularcontent">
                This Agreement will be governed exclusively by the laws of
                Canada. The courts located in the state of Ontario will have
                exclusive jurisdiction to adjudicate any dispute arising out of
                or relating to this Agreement. Each party hereby consents to the
                exclusive jurisdiction of such courts.
              </p>
              <h2 className="headingtermsec my-4">Limits</h2>
              <p className="regularcontent">
                NIIT Canada have the right to limit how you connect and interact
                with the Platform and our Services.
              </p>
              <p className="regularcontent">
                NIIT CANADA reserves the right to limit your use of the
                Services, including the number of your connections and your
                ability to contact other subscribers or users. NIIT CANADA
                reserves the right to restrict, suspend, or terminate your
                Account if you breach these Terms or the law or are misusing the
                Platform or Services (e.g., violating any of the Dos and
                Don’ts).
              </p>
              <h1 className="headingtermsec my-4">
                Disclaimer and Limit of Liability
              </h1>
              <h2 className="headingtermsec my-4">No Warranty</h2>
              <p className="regularcontent">
                This is our disclaimer of legal liability for the quality,
                safety, or reliability of our Services.
              </p>
              <p className="boldcontent">
                NIIT CANADA AND ITS AFFILIATES MAKE NO REPRESENTATION OR
                WARRANTY ABOUT THE PLATFORM OR SERVICES, INCLUDING ANY
                REPRESENTATION THAT (I) THE PLATFORM OR SERVICES WILL BE
                UNINTERRUPTED OR ERROR-FREE, (II) THE PLATFORM OR SERVICES WILL
                BE COMPATIBLE WITH YOUR COMPUTER AND RELATED EQUIPMENT AND
                SOFTWARE; (III) THE PLATFORM OR SERVICES WILL BE AVAILABLE OR
                WILL FUNCTION WITHOUT INTERRUPTION OR WILL BE FREE OF ERRORS OR
                THAT ANY ERRORS WILL BE CORRECTED; (IV) THE USE OF THE PLATFORM
                OR SERVICES WILL NOT INFRINGE THE RIGHTS (INCLUDING THE
                INTELLECTUAL PROPERTY RIGHTS) OF ANY PERSON; AND NIIT CANADA
                HEREBY DISCLAIMS ANY AND ALL LIABILITY REGARDING SUCH MATTERS TO
                THE FULLEST EXTENT PERMITTED BY LAW. THE PLATFORM OR SERVICES
                (INCLUDING CONTENT AND INFORMATION) ARE PROVIDED ON AN “AS IS”
                AND “AS AVAILABLE” BASIS. THE INFORMATION, AND CONTENT INCLUDED
                IN THE PLATFORM, DESPITE OUR EFFORTS, MAY NOT BE ACCURATE, OR
                APPLICABLE TO THE CIRCUMSTANCES OF ANY PARTICULAR CASE. IN
                ADDITION, THE INTEGRITY OF THE PLATFORM AND THE USE MADE OF THE
                PLATFORM CANNOT BE GUARANTEED TO BE SECURE, FREE FROM VIRUSES,
                TROJAN HORSES, WORMS OR OTHER DESTRUCTIVE, OR DISRUPTIVE
                COMPONENTS, DEFECTS, OR ERROR-FREE AS INFORMATION COULD BE
                INTERCEPTED, CORRUPTED, LOST, OR DESTROYED.TO THE FULLEST EXTENT
                PERMITTED UNDER APPLICABLE LAW, NIIT CANADA AND ITS AFFILIATES
                DISCLAIM ANY IMPLIED OR STATUTORY WARRANTY, INCLUDING ANY
                IMPLIED WARRANTY OF TITLE, ACCURACY OF DATA, NON-INFRINGEMENT,
                MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
              </p>
              <h2 className="headingtermsec my-4">Exclusion of Liability</h2>
              <p className="regularcontent">
                These are the limits of legal liability NIIT Canada may have to
                you.
              </p>
              <p className="boldcontent">
                TO THE FULLEST EXTENT PERMITTED BY LAW (AND UNLESS NIIT CANADA
                HAS ENTERED INTO A SEPARATE WRITTEN AGREEMENT THAT OVERRIDES
                THESE TERMS), NIIT CANADA, INCLUDING ITS AFFILIATES, WILL NOT BE
                LIABLE IN CONNECTION WITH ANY INACCURACIES OR OMISSIONS OR FOR
                ANY DAMAGE, HOWEVER, CAUSED, THAT MAY BE SUSTAINED AS A RESULT
                OF MALICIOUS CONTENT, MALWARE, OR SOFTWARE VIRUSES/DEFECTS
                CONTAINED IN OR ON THE PLATFORM, AS WELL AS DATA CORRUPTION,
                FAILED MESSAGES, TRANSMISSION ERRORS OR PROBLEMS, LINKS TO
                THIRD-PARTY WEBSITES, THIRD-PARTY CONTENT, PRODUCTS OR SERVICES,
                THE USE OF INABILITY TO USE THE PLATFORM OR THE SERVICES.
              </p>
              <p className="boldcontent">
                IN NO EVENT SHALL NIIT CANADA BE LIABLE TO THE CUSTOMER FOR ANY
                CONSEQUENTIAL, SPECIAL, INCIDENTAL OR INDIRECT DAMAGES OF ANY
                KIND ARISING OUT OF THE USE OR INABILITY TO USE THE PLATFORM,
                EVEN IF THE CUSTOMER HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH
                DAMAGES, OR ANY CLAIM BY A THIRD PARTY.
              </p>
              <p className="boldcontent">
                NIIT CANADA’S AND ITS AFFILIATES’ ENTIRE LIABILITY AND YOUR
                EXCLUSIVE REMEDY UNDER THIS AGREEMENT IN RESPECT OF THE SERVICES
                SHALL NOT EXCEED THE GREATER AMOUNT BETWEEN, (A) THE TOTAL FEES
                PAID BY YOU TO NIIT CANADA FOR THE SERVICES DURING THE TWELVE
                (12) PRECEEDING MONTHS, IF ANY, OR (B) CAD $1000, whichever is
                greater.
              </p>

              <h4 className="regularcontent my-4">
                Basis of the Bargain; Exclusions
              </h4>
              <p className="regularcontent">
                The limitations of liability mentioned above are part of the
                basis of the bargain between you and NIIT Canada and shall apply
                to all claims of liability (e.g., warranty, tort, negligence,
                contract and law) even if NIIT CANADA or its affiliates has been
                told of the possibility of any such damage, and even if these
                remedies fail their essential purpose.
              </p>
              <p className="regularcontent">
                These limitations of liability do not apply to liability for
                death or personal injury or for fraud, gross negligence or
                intentional misconduct, or in cases of negligence where a
                material obligation has been breached, a material obligation
                being such which forms a prerequisite to our delivery of
                services and on which you may reasonably rely, but only to the
                extent that the damages were directly caused by the breach and
                were foreseeable upon conclusion of these Terms and to the
                extent that they are typical in the context of these Terms.
              </p>

              <h2 className="headingtermsec my-4">
                User purchases and upgrades
              </h2>
              <p className="regularcontent">
                You will be able to purchase many different items on the
                Platform. For example, you may purchase a NIIT master class, or
                a course from one of our service provider partners. The purchase
                will be made online on the Platform through the ecommerce area.
                You can upgrade to different subscription packages by selecting
                the subscription package and paying the monthly subscription
                amount for that subscription package. You can also downgrade
                from any upgraded subscription package. If you purchase an
                upgrade, you will be required to accept the User Privacy Policy,
                Cookies and applicable Terms of Service.
              </p>
              <h2 className="headingtermsec my-4">Cancellation</h2>
              <p className="regularcontent">
                Individual purchase Downgrade from and upgraded subscription
                package.
              </p>
              <p className="regularcontent">
                You may downgrade from an upgraded subscription package at any
                time if you purchased an upgrade to package subscribed by the
                Account holder. The cancellation will be effective as of the
                next monthly billing cycle and you will be billed at such time.
              </p>
              <p className="regularcontent">
                Users purchasing any e-Learning content or videos whether it is
                NIIT Canada’s content or of any Third-party service providers,
                cannot cancel after purchase and there will be no refunds.
              </p>
              <p className="regularcontent">
                Users can cancel a purchase of an ILT (Instructor lead Training)
                or VILTS (Virtual instructor lead training) prior to 30 days of
                the scheduled training for a full refund for e.g. If the
                training is scheduled on Nov 1st, any cancellation prior to Sep
                30th will be applicable for a full refund.
              </p>
              <p className="regularcontent">
                For ILT or VILTS, these conditions apply for third party
                services for which any user purchases. For other third-party
                service provider purchases by the user, the user will be subject
                to the third-party service providers cancellation and refund
                policies. NIIT Canada has no control over any third-party
                service provider. NIIT Canada is not responsible for the content
                provided by third-party service providers and shall not be
                liable for any damages or injury arising from your use of such
                service. Accordingly, we recommend that you read the applicable
                third-party terms of use, cancellation and refund policies, and
                privacy policies for more information. Users who cancel a
                purchase of an ILT (Instructor lead Training) or VILTS (Virtual
                instructor lead training) within 30 days or less of the
                scheduled training will not be eligible for a refund for e.g. If
                the training is scheduled on Nov 1st, any cancellation post to
                Sep 30th will not be eligible for a refund.
              </p>
              <h2 className="headingtermsec my-4">Refunds</h2>
              <p className="regularcontent">
                For ILT and VILTS, after NIIT Canada receives your request for
                cancellation prior to 30 days of the class start date, NIIT
                Canada will initiate the process for your refund. Refunds will
                be sent to your original method of payment. Please allow at
                least fifteen (15) days from our receipt of your cancellation
                request, for processing at our end. Refunds might take 1-2
                billing cycles to post to your credit card statement, depending
                on your bank. NIIT Canada will notify you by email when your
                refund has been processed at our end. Needless to add, no amount
                shall be refunded if the request for refund is received less
                than 30 days prior to class start date.
              </p>
              <h2 className="headingtermsec my-4">Chargeback</h2>
              <ul>
                <li>
                  <p className="regularcontent">
                    NIIT reserves the right to charge the Client with an
                    administrative processing fee (including bank charges), if a
                    chargeback is placed by the Client with his/her credit card
                    company for whatever reason) for any amounts previously paid
                    by the Client to NIIT through credit card. This fee will
                    cover all expenses incurred related to the charge back
                    including bank charges and administrative effort to validate
                    the transaction.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    In the event of a chargeback placed by you with your credit
                    card Company for whatever reason) for any payment by credit
                    card made by you, NIIT Canada reserves the right to block
                    your account and validate the chargeback request. The
                    blocked account will only be released if the chargeback is
                    found to be valid.
                  </p>
                </li>
                <li>
                  <p className="regularcontent">
                    Third party service provider purchases by the user will be
                    subject to the third-party service providers cancellation
                    and refund policies.
                  </p>
                </li>
              </ul>

              <h2 className="headingtermsec my-4">
                Intellectual Property Rights
              </h2>
              <p className="regularcontent">
                NIIT Canada is providing you notice about our intellectual
                property rights.
              </p>
              <p className="regularcontent">
                As between the parties, NIIT CANADA reserves all its
                intellectual property rights in the Platform and Services.
                Copyrights, trademarks and logos used in connection with the
                Platform or Services are the trademarks of their respective
                owners. NIIT CANADA, and “NIIT” logos and trademarks, service
                marks, graphics and logos used for the Platform and Services are
                trademarks or registered trademarks of NIIT. No permission is
                given by NIIT Canada for their use, distribution, modification,
                or reproduction by any other person, and such use may constitute
                an infringement of the holders’ rights. It is strictly
                prohibited to use in any way the trade names, trademarks and
                logos displayed on the Platform or Services or any other word,
                expression, name or symbol which could cause confusion as to the
                link or association of the user with NIIT Canada or its
                endorsement or sponsorship of user’s products or services.
                Nothing appearing on the Platform or Services or elsewhere shall
                be construed as granting, by implication, estoppel, or
                otherwise, any licence or right to use any trade names,
                trademarks and logos displayed on the Platform or Services.
              </p>
              <p className="regularcontent">
                Our Platform contains open source and public domain content,
                licensed content as well as proprietary content owned by us and
                by third parties.
              </p>
              <p className="regularcontent">
                As between the parties, you further acknowledge that title and
                full ownership rights with respect to the Platform and Services
                will remain the exclusive property of NIIT Canada, and you will
                not acquire any rights to the Platform or Services, except as
                expressly set forth in these Terms. All title and copyrights in
                and to the Platform (including but not limited to any training
                materials, presentations, or classes to be purchased by users,
                as well as any images, photographs, page headers, custom
                graphics, button icons, scripts and the presentation,
                arrangement, coordination, enhancement animations and selection
                of such and other information in text, graphical, video and
                audio form, music, images, icons, software, designs,
                applications, data, text and “applets,” and other elements
                available on or incorporated into the Platform [the “Content”]),
                are owned by NIIT Canada. The Platform is protected by copyright
                laws and international treaty provisions.{" "}
              </p>
              <p className="regularcontent">
                All feedback, comments, and suggestions for improvements (the
                "Feedback") that you provide to us, will become our property.
                You agree that NIIT Canada is not required to (i) use any
                Feedback, (ii) identify you when using any Feedback you may have
                submitted nor (iii) treat any Feedback as confidential, and will
                be entitled to use the Feedbacks, or any part thereof for any
                purposes whatsoever. By submitting Feedback, you hereby grant
                (or warrant that the owner of the Feedback grants) to NIIT
                Canada and its assigns a perpetual, royalty-free, irrevocable,
                unrestricted, non-exclusive, assignable, transferable,
                sublicensable, right and licence to copy, modify, publish,
                create derivative works from, distribute, publicly display and
                otherwise use the Feedback or any ideas, concepts, know-how or
                techniques associated with the Feedback for any purpose
                whatsoever. You also agree, represent and warrant that all moral
                rights in the Feedback are waived in favour of NIIT Canada and
                its assigns.
              </p>

              {false && (
                <>
                  {" "}
                  <h2 className="headingtermsec my-4">Automated Processing</h2>
                  <p className="regularcontent">
                    We do not conduct any automated processing of data. We use
                    the information and data that you provide and that we have
                    about data subjects to make recommendations for content and
                    features that may be useful. For example, we use your data
                    to recommend other courses and content that may be useful
                    for your training purposes.
                  </p>{" "}
                </>
              )}

              <h2 className="headingtermsec my-4">Third Party Materials</h2>
              <p className="regularcontent">
                The Platform or Services may display, include or make available
                third-party content (including data, content, materials, and
                information in any form or medium, software, and other products,
                services and/or materials including specifications, or products)
                or provide links to third-party websites or services, including
                through third-party advertising, relating to the Software that
                are not proprietary to NIIT Canada. You acknowledge and agree
                that NIIT Canada is not responsible for such materials and
                content, including their accuracy, completeness, timeliness,
                validity, copyright compliance, legality, decency, quality or
                any other aspect thereof. NIIT Canada does not assume and will
                not have any liability or responsibility to you or any other
                person or entity for any of such content and materials. The
                content, materials and links thereto are provided solely as a
                convenience to you and its access and use of them are entirely
                at your own risk and subject to such third parties’ terms and
                conditions.
              </p>

              <h2 className="headingtermsec my-4">Contact Us</h2>
              <p className="regularcontent">
                If you have any questions, you may contact us as listed below:
              </p>
              <p className="regularcontent">
                NIIT Learning Solutions Canada Limited.
              </p>
              <p className="regularcontent">
                Postal address: Waterfront Center, #1200-200 Burrard Street,
                Vancouver, BC V6C 3L6 Canada
              </p>
              <p>
                <span class="boldcontent">EMAIL: </span>
                <span className="regularcontent">Support@halifax.app</span>
              </p>

              <p className="boldcontent">
                NIIT Learning Solutions (Canada) Limited [NIIT Canada] User
                Terms of Service{" "}
              </p>
              <p className="regularcontent">
                By clicking on the “I Agree” button below, you acknowledge that
                you have read, understood, and agree to be bound by NIIT
                Canada’s User Terms of Service.
              </p>

              <p className="boldcontent">
                PLEASE READ THE USER TERMS OF SERVICE (“TERMS”) CAREFULLY BEFORE
                CLICKING THE “I AGREE” BUTTON OR USING THE PLATFORM OR THE
                SERVICES. BY CLICKING THE “I AGREE” BUTTON OR USING THE
                PLATFORM, YOU ARE ENTERING INTO AND AGREEING TO BE BOUND BY
                THESE TERMS.
              </p>
              <p className="boldcontent">
                IF YOU DO NOT AGREE TO THESE TERMS, DO NOT CLICK THE “I AGREE”
                BUTTON OR USE THE [NIIT] PLATFORM OR SERVICES.
              </p>
              <div className="form-check cursor-pointer">
                <input
                  className="form-check-input cursor-pointer"
                  type="checkbox"
                  id="termofusein"
                  checked={check}
                  onChange={() => {
                    if (check) setCheck(false);
                    else setCheck(true);
                  }}
                />
                <label
                  className="form-check-label cursor-pointer"
                  for="termofusein"
                >
                  I have read the Terms.
                </label>
              </div>
            </div>

            <div className="text-center btnboxprivacy pt-5 pb-5">
              <button
                className="btn-procced-agree btn-primary"
                onClick={() => {
                  if (isAndroid || isIOS) {
                    try {
                      // alert("Window CallbackHanlder");
                      if (window.callbackHandler != undefined) {
                        window.callbackHandler.postMessage("link");
                      }
                      if (window.webkit != undefined) {
                        if (
                          window.webkit.messageHandlers.callbackHandler !=
                          undefined
                        ) {
                          window.webkit.messageHandlers.callbackHandler.postMessage(
                            "link"
                          );
                        }
                      }
                      setTimeout(() => {
                        window.open(
                          "/view-user-terms",
                          "_blank"
                        );
                      }, 500);
                    } catch (err) {
                      window.open(
                        "/view-user-terms",
                        "_blank"
                      );
                    }
                  } else {
                    window.open(
                      "/view-user-terms",
                      "_blank"
                    );
                  }
                }}
              >
                View User Terms of Service
              </button>
              <button
                className="btn-procced-agree btn-primary"
                onClick={() => {
                  if (isAndroid || isIOS) {
                    try {
                      // alert("Window CallbackHanlder");
                      if (window.callbackHandler != undefined) {
                        window.callbackHandler.postMessage("dont-aggree");
                      }
                      if (window.webkit != undefined) {
                        if (
                          window.webkit.messageHandlers.callbackHandler !=
                          undefined
                        ) {
                          window.webkit.messageHandlers.callbackHandler.postMessage(
                            "dont-aggree"
                          );
                        }
                      }

                      setTimeout(() => {
                        signOut();
                      }, 500);
                    } catch (err) {
                      signOut();
                    }
                  } else {
                    signOut();
                  }
                }}
              >
                I Don’t Agree
              </button>
              <button
                className="btn-procced-agree btn-primary"
                onClick={() => {
                  if (isAndroid || isIOS) {
                    try {
                      // alert("Window CallbackHanlder");
                      if (webView === "true") {
                        if (window.callbackHandler !== undefined) {
                          window.callbackHandler.postMessage("aggree");
                        }
                        if (window.webkit !== undefined) {
                          if (
                            window.webkit.messageHandlers.callbackHandler !=
                            undefined
                          ) {
                            window.webkit.messageHandlers.callbackHandler.postMessage(
                              "aggree"
                            );
                          }
                        }
                        return;
                      }
                      setTimeout(() => {
                        setIsLoading(true);
                        dispatch(
                          isAggree({
                            module: "isAggree",
                            postData: {
                              token: localStorage.getItem(
                                SessionKeys.API_TOKEN_BROKER
                              ),
                              isagreed: "yes",
                            },
                          })
                        );
                      }, 500);
                    } catch (err) {
                      setIsLoading(true);
                      dispatch(
                        isAggree({
                          module: "isAggree",
                          postData: {
                            token: localStorage.getItem(
                              SessionKeys.API_TOKEN_BROKER
                            ),
                            isagreed: "yes",
                          },
                        })
                      );
                    }
                  } else {
                    setIsLoading(true);
                    dispatch(
                      isAggree({
                        module: "isAggree",
                        postData: {
                          token: localStorage.getItem(
                            SessionKeys.API_TOKEN_BROKER
                          ),
                          isagreed: "yes",
                        },
                      })
                    );
                  }
                }}
                disabled={check ? false : true}
              >
                I Agree
              </button>
            </div>
          </div>
          <div className="col-md-4">
            <img
              src="images/privacy-policy.png"
              alt="privacy-policy"
              className="img-fluid privacy-rghypos"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default PrivacyandTerms;
